import { createAction } from '@reduxjs/toolkit';

export class CancelCheckSignVisit {
  static get action() {
    return createAction('profile/CANCEL_CHECK_GOOGLE_VISIT');
  }
}
